import React, { Component } from 'react';
import TextEditorButton from '../text-editor-button';

export default function createButton({ className, displayName, content: Content, tooltipText }) {
  return class extends Component {
    static displayName = displayName;
    render() {
      return <TextEditorButton className={className} icon={Content} tooltipText={tooltipText} {...this.props}/>;
    }
  };
}



// WEBPACK FOOTER //
// ./app/components/text-editor/utils/create-button.js